__webpack_require__.p = "/covid-ampel-widget/";